/** Traductions modal détails commande (FR / AR) */
export const orderDetailsModalFr = {
  title: 'Détails de la commande',
  orderId: 'N° commande',
  orderDate: 'Date de commande',
  expectedDelivery: 'Livraison prévue',
  status: 'Statut',
  totalAmount: 'Montant total',
  supplierSection: 'Informations fournisseur',
  name: 'Nom',
  company: 'Entreprise',
  email: 'Email',
  phone: 'Téléphone',
  supplierNotFound: 'Informations fournisseur introuvables',
  productsSection: 'Produits',
  colProduct: 'Produit',
  colQuantity: 'Quantité',
  colUnitPrice: 'Prix unitaire',
  colTotal: 'Total',
  productUnknown: 'Produit inconnu'
};

export const orderDetailsModalAr = {
  title: 'تفاصيل الطلب',
  orderId: 'رقم الطلب',
  orderDate: 'تاريخ الطلب',
  expectedDelivery: 'التسليم المتوقع',
  status: 'الحالة',
  totalAmount: 'إجمالي المبلغ',
  supplierSection: 'معلومات المورد',
  name: 'الاسم',
  company: 'الشركة',
  email: 'البريد الإلكتروني',
  phone: 'الهاتف',
  supplierNotFound: 'معلومات المورد غير متوفرة',
  productsSection: 'المنتجات',
  colProduct: 'المنتج',
  colQuantity: 'الكمية',
  colUnitPrice: 'السعر للوحدة',
  colTotal: 'الإجمالي',
  productUnknown: 'منتج غير معروف'
};
